@if (uploadedFileLabel) {
  <div class="file-upload-selected-container">
    <div class="uploaded-file-item">
      <rkt-icon class="file-status" name="check"></rkt-icon>
      <div class="name">{{ uploadedFileLabel }}</div>
      <button type="button" (click)="onReplaceBtnClick()" class="delete-file-btn">Replace</button>
    </div>
  </div>
}

@if (fileName) {
  <div class="file-upload-selected-container">
    <div class="uploaded-file-item">
      <rkt-icon class="file-status" name="check"></rkt-icon>
      <div class="name">{{ fileName }}</div>
      <button type="button" (click)="onDeleteFileBtnClick()" class="delete-file-btn">Delete</button>
    </div>
  </div>
} @else {
  <div
    [hidden]="uploadedFileLabel"
    class="file-upload-container"
    [class.hovering]="isDragging"
    (drop)="onDrop($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="stopDrag($event)"
    (dragend)="stopDrag($event)"
  >
    <button type="button" class="upload-btn rbnk-btn btn-success" (click)="fileSelector.click()">
      <rkt-icon name="camera" class="upload-btn-icon"></rkt-icon>
      Upload file
    </button>
    <input #fileSelector type="file" [accept]="fileTypes.join(', ')" (change)="onFileSelected($event)" hidden />
  </div>
}
